import React, { useState, useEffect } from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import Hospital from "./Hospital";
import Pharmacy from "./Pharmacy";
import Lab from "./Lab";
import Fitness from "./Fitness";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const Facility = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab") || "Hospital";
  const pageFromUrl = parseInt(queryParams.get("page") || "1", 10);

  const [activeTab, setActiveTab] = useState(tabFromUrl);

  useEffect(() => {
    setActiveTab(tabFromUrl);
    dispatch(setCurrentPage(pageFromUrl));
  }, [tabFromUrl, pageFromUrl, dispatch]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(setCurrentPage(1));
    navigate(`/facilities?page=1&tab=${tab}`);
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Facilities"} />
        <div className="loaction-list-main">
          <div className="request-selection">
            <ul>
              <li
                className={activeTab === "Hospital" ? "request-active" : ""}
                onClick={() => handleTabClick("Hospital")}
              >
                Hospital
              </li>
              <li
                className={activeTab === "Pharmacy" ? "request-active" : ""}
                onClick={() => handleTabClick("Pharmacy")}
              >
                Pharmacy
              </li>
              <li
                className={activeTab === "Laboratory" ? "request-active" : ""}
                onClick={() => handleTabClick("Laboratory")}
              >
                Laboratory
              </li>
              <li
                className={
                  activeTab === "Fitness Centre" ? "request-active" : ""
                }
                onClick={() => handleTabClick("Fitness Centre")}
              >
                Fitness Centre
              </li>
            </ul>
          </div>
          {activeTab === "Hospital" && <Hospital />}
          {activeTab === "Pharmacy" && <Pharmacy />}
          {activeTab === "Laboratory" && <Lab />}
          {activeTab === "Fitness Centre" && <Fitness />}
        </div>
      </div>
    </div>
  );
};

export default Facility;
